var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"data":_vm.tableData,"columns":_vm.columns,"narrowed":true,"mobile-cards":false},scopedSlots:_vm._u([{key:"header",fn:function(props){return undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }